module.exports = __webpack_public_path__ + "img/3.3d4d8764.png";